import Header from "../Components/Header";
import Error from "./Error";
const ErrorWrapper = () => (
    <>
      <Header />
      <Error />
    </>
  );
export default ErrorWrapper;